/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Grid, Row, Col } from 'react-bootstrap';
import s from './ServicesFooter.scss';
import { saveFooterHeight } from '../../actions/eservices';
import { fetchDistrictList } from '../../actions/app';
import DistrictDetails from './DistrictDetails';
import WideLogo from './WideLogo';

class ServicesFooterClass extends React.Component {
  state = {
    prefix: null,
    footerDescription: null,
  }

  componentDidMount() {
    if (!this.props.districts) {
      fetch(`${process.env.API_URL}/app_district`, {
        method: 'GET',
      })
      .then(response => response.json())
      .then(resp => {
        const keys = Object.keys(resp);
        const prefix = keys[0];
        const footerDescription = resp[prefix].footerDescription;
        if (prefix !== undefined) {
          this.setState({ prefix, footerDescription }, () => this.getFooterHeight());
        }
      });
    }
  }
  // componentDidUpdate() {
  //   this.getFooterHeight();
  // }

  // componentDidUpdate(prevProps) {
  //   if (prevProps.prefix !== this.props.prefix && prevProps.prefix !== this.state.prefix && this.props.prefix !== undefined) {
  //     this.props.fetchDistrictArms(this.props.prefix);
  //   }
  // }

  getFooterHeight = () => {
    const foot = this.footer;
    const footHeight = foot.getBoundingClientRect().height;
    this.props.saveFooterHeight(footHeight);
  }

  getYear = () => {
    const d = new Date();
    const n = d.getFullYear();
    return n;
  };

  render() {
    return <footer ref={x => this.footer = x} style={this.props.colors} className="servicesFooter my-bg footer" id="layout-footer">
      <Grid>
        <Row>
            <Col xs={3} style={{ display: 'flex', justifyContent: 'center' }}>
              {
                this.state.prefix && this.props.arms ?
                  <img height={'60'} src={`https://e-spdp.pl/oldihub/upload/herby/${this.props.arms}`} />
                  : null
              }
            </Col>
            <Col xs={9} />
          </Row>
          <Row>
            <Col xs={12} sm={3} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '10px' }}>
              {
                this.state.prefix !== undefined ?
                  <DistrictDetails prefix={this.state.prefix} />
                  : null
              }
            </Col>
            <Col xs={12} sm={6} >
              {
                this.state.prefix !== undefined ?
                  <WideLogo prefix={this.state.prefix} />
                  : null
              }
            </Col> 
            {/* ZMIENIĆ NA POBIERANE Z BAZY */}
            <Col xs={12} sm={3} className="services-footer-col-right">
            <div dangerouslySetInnerHTML={{ __html: this.state.footerDescription }}></div>
            </Col>
          </Row>
      </Grid>
      <div className="giap_link">
        <a className="link" href="http://www.giap.pl/">
          GIAP © {this.getYear()}
        </a>
      </div>
    </footer>
    {/* <div className="info-tech">
      <b>Uwaga! Trwają prace nad przebudową portalu. Portal może nie działać prawidłowo. Pracujemy nad przywróceniem wszystkich funkcjonalności.</b>
    </div> */}
    ;
  }
}

const mapState = state => ({
  arms: state.eservices.arms,
});

const mapDispatch = {
  saveFooterHeight,
};

const ServicesFooter = connect(mapState, mapDispatch)(ServicesFooterClass);

export default withStyles(s)(ServicesFooter);



// WEBPACK FOOTER //
// src/components/ServicesFooter/ServicesFooter.js